<script lang="ts">
    import type { LCDTextFragment } from '@amp/web-app-components/src/components/LCDMetadata/types';
    import { createEventDispatcher } from 'svelte';

    export let contentItem: LCDTextFragment;
    export let isCopy: boolean = false;

    const dispatch = createEventDispatcher();

    $: isInert = contentItem?.isInert;
    $: action = contentItem?.action;
    $: useAction = !!action && !isInert;
    $: tabIndex = !useAction || isCopy ? -1 : 0;

    function handleClick(): void {
        dispatch('navigate', { action });
    }
</script>

{#if contentItem}
    {#if !!contentItem.icon}
        <span
            class="marquee-line__fragment marquee-line__icon"
            aria-label={contentItem.text}
            role="img"
            data-testid="marquee-text-icon"
        >
            <amp-icon name={contentItem.icon} />
        </span>
    {:else}
        <!-- TODO: Confirm span tabindex not needed? -->
        <span class="marquee-line__fragment" data-testid="marquee-text-item">
            {#if useAction}
                <button
                    class="lcd-meta-line__fragment"
                    data-testid="marquee-text-item-button"
                    tabindex={tabIndex}
                    on:click|preventDefault|stopPropagation={handleClick}
                >
                    {contentItem.text}
                </button>{contentItem.separator || ''}
            {:else}
                {contentItem.text}{contentItem.separator || ''}
            {/if}
        </span>
    {/if}
{/if}

<style lang="scss">
    @use 'ac-sasskit/core/helpers' as *;
    @use '@amp/web-shared-styles/app/core/mixins/marquee' as *;

    .marquee-line__fragment {
        color: inherit;
        text-decoration: none;
    }

    .marquee-line__icon {
        display: flex;
        align-items: center;

        amp-icon {
            width: var(--lcd-meta-explicit-icon-size, 12px);
            height: var(--lcd-meta-explicit-icon-size, 12px);
            color: var(--lcd-meta-icon-color, var(--systemSecondary));
        }
    }

    .lcd-meta-line__fragment {
        &:hover {
            color: var(--keyColor);
            text-decoration: var(
                --marquee-line-text-decoration-hover,
                underline
            );
        }
    }
</style>
